import {
  ApiResponse,
  ChangeMyPasswordDTO,
  CreateUserDTO,
  GetUserPayload,
  GetUsersFilters,
  GetUsersPayload,
  UpdateUserDTO,
} from '@mrp-system/common';
import api from 'config/api';
import { APIError } from 'error/APIError';
import { handleRequest } from 'utils/api-utils';

export const changeMyPassword = async (formData: ChangeMyPasswordDTO) => {
  const { data, headers } = await api.post<ApiResponse<null>>(
    '/user/change-my-password',
    formData
  );

  if (data.status === 'SUCCESS' || data.status === 'WARNING') {
    return data;
  } else {
    throw new APIError(data.message, data, headers);
  }
};

export const getUsers = async (filters?: GetUsersFilters) => {
  const { data, headers } = await api.get<ApiResponse<GetUsersPayload>>(
    '/user',
    {
      params: filters,
    }
  );

  if (data.status === 'SUCCESS' || data.status === 'WARNING') {
    return data;
  } else {
    throw new APIError(data.message, data, headers);
  }
};

export const getUser = async (id: number) => {
  const { data, headers } = await api.get<ApiResponse<GetUserPayload>>(
    `/user/${id}`
  );

  if (data.status === 'SUCCESS' || data.status === 'WARNING') {
    return data;
  } else {
    throw new APIError(data.message, data, headers);
  }
};

export const createUser = async (user: CreateUserDTO) => {
  return await handleRequest(
    async () => await api.post<ApiResponse<GetUserPayload>>(`/user`, user)
  );
};

export const updateUser = async (id: number, user: UpdateUserDTO) => {
  return await handleRequest(
    async () => await api.put<ApiResponse<GetUserPayload>>(`/user/${id}`, user)
  );
};
